// @flow

import React, { Fragment } from 'react';
import { FormFieldDescription, FormFieldValueContent, FormFieldValue, FormFieldValueHelp } from '..';
import { ArrayField } from './ArrayField';
import { EnumField } from './EnumField';
import { StringField } from './StringField';

export const FieldRow = ({ field }: { field: Object }) => {
  const fieldComponents = {
    string: StringField,
    array: ArrayField,
    enum: EnumField
  };

  const Component = fieldComponents[field.type];

  return (
    <Fragment>
      <FormFieldDescription>{field.definition.name}</FormFieldDescription>
      <FormFieldValueContent>
        <FormFieldValue>
          <Component nameField={field.fieldName} userValue={field.userValue} definition={field.definition} />
        </FormFieldValue>

        <FormFieldValueHelp></FormFieldValueHelp>
      </FormFieldValueContent>
    </Fragment>
  );
};
